import { render, staticRenderFns } from "./CategoryAutocomplete.vue?vue&type=template&id=05364e44&scoped=true&"
import script from "./CategoryAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CategoryAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAutocomplete.vue?vue&type=style&index=0&id=05364e44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05364e44",
  null
  
)

export default component.exports